import ForgotPasswordSuccess from './ForgotPasswordSuccess'

export default ForgotPasswordSuccess
